import * as History from "history"
import { observer } from "mobx-react"
import * as React from "react"
import { useEffect, useState } from "react"
import { Redirect, Route, Router, Switch } from "react-router-dom"
import { Maze } from "../babylon/activities/maze/Maze"
import { MainGame } from "../phaser/MainGame"
import { AuthStoreSA } from "../react/login/AuthStoreSA"
import { WebApp } from "../react/WebApp"
import { AppType } from "./AppType"
import { CCUtils } from "./CCUtils"
import { log } from "./Logging"

export const browserHistory = History.createBrowserHistory()

/**
 * This is technically react, but it's used by all the apps in common to route between apps.
 */
export class AppsRouter extends React.Component {
    render() {
        return (
            <Router history={browserHistory}>
                <Switch>
                    <Route
                        path={AppRoutes.activities}
                        render={() => <LoadApp app={AppType.PHASER} />}
                    />
                    <Route
                        path={AppRoutes.threeDActivities}
                        render={() => <LoadApp app={AppType.BABYLON} />}
                    />
                    <Route render={() => <LoadApp app={AppType.REACT} />} />
                </Switch>
            </Router>
        )
    }
}

const background = CCUtils.asset("web/images/click-city-background.jpg")

@observer
class LoadApp extends React.Component<{ app: AppType }> {
    componentDidMount() {
        this.onUpdate()
    }

    componentDidUpdate() {
        this.onUpdate()
    }

    onUpdate = () => {
        const { app } = this.props

        if (app === AppType.REACT) {
            document.body.style.backgroundImage = `url(${background})`
        } else {
            document.body.style.backgroundImage = ""
        }
    }

    render() {
        const { app } = this.props
        log.debug(`Rendering app ${app}`)

        if (app === AppType.REACT) {
            return <WebApp />
        } else {
            if (!AuthStoreSA.instance.studentIsFullyLoaded) {
                // Prevents errors with unloaded students when reloading from the non-login pages
                return <Redirect to={AppRoutes.home} />
            }

            if (app === AppType.BABYLON) {
                return <LoadBabylon />
            } else {
                return <LoadPhaser />
            }
        }
    }
}

export const AppRoutes = {
    home: "/",
    activities: "/activities",
    threeDActivities: "/3d-activities",
}

export const activateApp = (switchTo: AppType) => {
    let goTo
    if (switchTo === AppType.PHASER) {
        goTo = AppRoutes.activities
    } else if (switchTo === AppType.BABYLON) {
        goTo = AppRoutes.threeDActivities
    } else {
        goTo = AppRoutes.home
    }
    browserHistory.push(goTo)
}

const LoadPhaser = () => {
    const [phaserGame] = useState(new MainGame())

    useEffect(() => {
        log.debug("Loading phaser")
        return () => {
            log.debug("Destroying phaser")
            phaserGame.destroy()
        }
    }, [phaserGame])

    return <div id={"phaser-app"} />
}

class LoadBabylon extends React.Component {
    private babylonGame?: Maze

    componentDidMount() {
        this.onUpdate()
    }

    componentDidUpdate() {
        this.onUpdate()
    }

    onUpdate = () => {
        if (this.babylonGame) {
            log.debug("Dispose bab game in update")
            this.babylonGame.dispose()
        }
        log.debug("Initiate bab game in update")
        this.babylonGame = new Maze()
    }

    componentWillUnmount(): void {
        if (this.babylonGame) {
            log.debug("Dispose bab game in unmount")
            this.babylonGame.dispose()
        }
    }

    render() {
        // touch action set to none for PEP as per: https://doc.babylonjs.com/babylon101/first
        return (
            <canvas
                id={"babylon-app"}
                style={{
                    touchAction: "none",
                    WebkitUserSelect: "none",
                    MozUserSelect: "none",
                    msUserSelect: "none",
                    userSelect: "none",
                }}
            />
        )
    }
}
